module.exports = __webpack_public_path__ + "img/maneken_pos_3.cd614c77.png";